import { render, staticRenderFns } from "./Archive_Expenses.vue?vue&type=template&id=e159be7a"
import script from "./Archive_Expenses.vue?vue&type=script&lang=js"
export * from "./Archive_Expenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports